export default __webpack_public_path__ + "static/media/SchoolLogo.71c4b5cf.svg";